<template>
  <sunset-page-shell>
    <div class="not-found">
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">This page doesn’t exist</h1>
      <p class="not-found__lead">
        The link may be outdated, or the page was removed. Head back to the Workmorr home page to download
        the app.
      </p>
      <div class="not-found__actions">
        <router-link to="/" class="not-found__btn not-found__btn--primary"> Back to home </router-link>
        <a
          class="not-found__btn not-found__btn--ghost"
          href="https://play.google.com/store/apps/details?id=com.workmorr.workmorr"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Play
        </a>
        <a
          class="not-found__btn not-found__btn--ghost"
          href="https://apps.apple.com/gh/app/workmorr/id6473766809"
          target="_blank"
          rel="noopener noreferrer"
        >
          App Store
        </a>
      </div>
    </div>
  </sunset-page-shell>
</template>

<script>
import SunsetPageShell from '@/components/SunsetPageShell.vue'

export default {
  name: 'NotFound404View',
  components: { SunsetPageShell },
}
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 2rem 0 1rem;
  max-width: 26rem;
  margin: 0 auto;
}

.not-found__code {
  margin: 0 0 0.5rem;
  font-size: 3.5rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1;
  color: #008d36;
  text-shadow: 0 0 40px rgba(0, 141, 54, 0.35);
}

.not-found__title {
  margin: 0 0 1rem;
  font-size: clamp(1.5rem, 4vw, 1.85rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #f5f7fa;
}

.not-found__lead {
  margin: 0 0 2rem;
  font-size: 1.05rem;
  line-height: 1.55;
  color: #94a3b8;
}

.not-found__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  justify-content: center;
}

.not-found__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.85rem 1.35rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 999px;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.not-found__btn--primary {
  background: linear-gradient(135deg, #00b344 0%, #006b29 100%);
  color: #ffffff;
  box-shadow: 0 4px 20px -4px rgba(0, 141, 54, 0.5);
}

.not-found__btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px -4px rgba(0, 141, 54, 0.55);
}

.not-found__btn--ghost {
  background: rgba(255, 255, 255, 0.04);
  color: #f5f7fa;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.not-found__btn--ghost:hover {
  border-color: rgba(0, 141, 54, 0.35);
  transform: translateY(-2px);
}
</style>
